<template>
  <div class="input-file-margin">
    <label>
      <span class="input-file-title">{{ title }}</span>
      <span class="input-file-required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>

    <div class="input-file-control" :class="{
      'input-file-control-invalid': notifications.length > 0 && formDirty,
      'input-file-control-disabled': disabled,
    }">
      <button type="button" class="input-file-button" :disabled="disabled" @click="openPicker">
        <i class="fa-solid fa-paperclip"></i>
        <span>{{ buttonTitle }}</span>
      </button>
      <span class="input-file-name" :class="{ 'input-file-name-empty': !fileName }">
        {{ fileName || placeholder }}
      </span>
      <i v-if="fileName" class="fa-solid fa-xmark input-file-clear" @click="clear"></i>
      <input ref="input" type="file" class="input-file-hidden" :accept="accept" :disabled="disabled"
        @change="onChange" />
    </div>

    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="input-file-invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";

import { mapState, mapMutations } from "vuex";

export default {
  name: "InputFile",
  components: { Tip },
  props: {
    title: String,
    field: String,
    formName: String,
    required: Boolean,
    disabled: Boolean,
    accept: String,
    value: File,
    placeholder: {
      type: String,
      default: "Nenhum arquivo escolhido",
    },
    buttonTitle: {
      type: String,
      default: "Escolher arquivo",
    },
    markFormDirty: {
      type: Boolean,
      default: true,
    },
    changed: Function,
    cleaned: Function,
  },
  data() {
    return {
      notifications: [],
      formDirty: false,
    };
  },
  created() {
    this.validate();
  },
  computed: {
    ...mapState("validation", ["resetForm"]),
    fileName() {
      return this.value ? this.value.name : "";
    },
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    openPicker() {
      if (this.disabled) return;
      this.$refs.input.click();
    },
    onChange(event) {
      let file = event.target.files[0] || null;
      this.$emit("input", file);
      if (this.changed) this.changed();
    },
    clear() {
      this.$refs.input.value = "";
      this.$emit("input", null);
      if (this.cleaned) this.cleaned();
    },
    validate() {
      this.notifications = [];
      if (this.required && !this.value) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }
    },
  },
  watch: {
    value() {
      this.validate();
      this.formDirty = true;
      if (this.markFormDirty) this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) {
          if (this.$refs.input) this.$refs.input.value = "";
          this.$emit("input", null);
          this.formDirty = false;
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.input-file-margin {
  margin-bottom: 10px;
}

.input-file-title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: var(--text-primary);
  letter-spacing: 0.5px !important;
}

.input-file-required {
  color: var(--color-danger);
}

.input-file-control {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0;
  min-width: 300px;
  height: 38px;
  border: 1px solid var(--border-input);
  border-radius: 5px;
  background: var(--input-bg);
  overflow: hidden;
}

.input-file-control-invalid {
  border-color: var(--color-danger);
}

.input-file-control-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.input-file-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 100%;
  padding: 0 12px;
  border: none;
  border-right: 1px solid var(--border-input);
  background: var(--bg-elevated);
  color: var(--text-primary);
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.input-file-button:hover {
  background: var(--bg-hover);
}

.input-file-button:disabled {
  cursor: not-allowed;
}

.input-file-name {
  flex: 1;
  min-width: 0;
  padding: 0 10px;
  font-size: 13.5px;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.input-file-name-empty {
  color: var(--text-muted);
}

.input-file-clear {
  margin-right: 10px;
  color: var(--text-muted);
  font-size: 13px;
  cursor: pointer;
  flex-shrink: 0;
}

.input-file-clear:hover {
  color: var(--color-danger);
}

.input-file-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
}

.input-file-invalid {
  color: var(--color-danger);
  font-size: 14px;
}
</style>
